import { preload } from "../include/module";
preload();

import { loadAnime } from "../include/module";
loadAnime();

import { initScrollbar } from "../include/module";
initScrollbar();

import { toggleMenu } from "../include/module";
toggleMenu();



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js